import { CommonModule } from "@angular/common";
import { Component, computed, input, output } from "@angular/core";
import dayjs from "dayjs";

@Component({
    selector: "app-range-day",
    imports: [CommonModule],
    standalone: true,
    styleUrls: ["../range-calendar.component.scss"],
    templateUrl: "./range-day.component.html",
})
export class RangeDay {
    select = output<{ start: Date | null; end: Date | null }>();

    currentDate = input<Date>();
    day = input<dayjs.Dayjs>();
    start = input<Date>();
    end = input<Date>();

    has = computed(
        () =>
            dayjs(this.start()).isBefore(this.day()) &&
            dayjs(this.end()).isAfter(this.day()),
    );

    selected = computed(() => this.isStart() || this.isEnd());

    isStart = computed(
        () =>
            dayjs(this.start()).format("YYYY-MM-DD") ===
            this.day()?.format("YYYY-MM-DD"),
    );

    isEnd = computed(
        () =>
            dayjs(this.end()).format("YYYY-MM-DD") ===
            this.day()?.format("YYYY-MM-DD"),
    );

    isToday = computed<boolean>(
        () => dayjs().format("YYYY-MM-DD") === this.day()?.format("YYYY-MM-DD"),
    );

    textColor = computed(() => {
        if (
            dayjs(this.currentDate()).get("month") !== this.day()?.get("month")
        ) {
            return "prev-month";
        }

        if (this.selected()) {
            return "selected";
        }

        if (this.day()?.get("day") === 0) {
            return "sunday";
        }

        if (this.day()?.get("day") === 6) {
            return "saturday";
        }

        return "default";
    });
}
